import {
  LocalTrack,
  RemoteTrack,
  RemoteTrackPublication,
} from "livekit-client";
import { shallowReactive } from "vue";

export const usersVideoTracks = shallowReactive<{
  [key: string]: RemoteTrack | LocalTrack | null;
}>({});

export const trackToSubMap = new Map<RemoteTrack, RemoteTrackPublication>();
